import { defaultFill } from '../../utils/constants';
var muiEqualHousing24 = {
    paths: [
        {
            path: 'M12.2926829,0 L24,7.02439024 L24,9.36585366 L22.2439024,9.36585366 L22.2439024,18.1463415 L1.75609756,18.1463415 L1.75609756,9.36585366 L0,9.36585366 L0,7.02439024 L12.2926829,0 Z M12.2926829,2.34146341 L4.09756098,7.02439024 L4.09756098,15.804878 L19.902439,15.804878 L19.902439,7.02439024 L12.2926829,2.34146341 Z M7.6097561,8.19512195 L16.3902439,8.19512195 L16.3902439,10.5365854 L7.6097561,10.5365854 L7.6097561,8.19512195 Z M7.6097561,11.7073171 L16.3902439,11.7073171 L16.3902439,14.0487805 L7.6097561,14.0487805 L7.6097561,11.7073171 Z',
            fill: defaultFill,
        },
    ],
    title: 'Equal Housing',
    width: 24,
    height: 19,
};
var muiEqualHousing = {
    base: muiEqualHousing24,
    lgIcon: muiEqualHousing24,
};
export { muiEqualHousing };
//# sourceMappingURL=equalHousing.js.map